import { ref } from 'vue';
import { toast } from 'vue-sonner';
import useApi from '@/composables/useApi.ts';
import type { Vote } from '@/types';

export default function useFeedback(uid: string, initialVote: Vote = null) {
    const vote = ref<Vote>(initialVote);
    const response = ref('');
    const showFeedbackPopover = ref(false);

    const useFetch = useApi();

    async function recordVote(value: -1 | 1) {
        const { data, error } = await useFetch<{ success: boolean }>(
            'vote'
        ).post({
            uid,
            vote: value,
        });

        if (error.value) {
            toast.error('Ihre Rückmeldung konnte nicht gespeichert werden.');
            console.error(error.value);
            return;
        }

        if (data.value?.success === true) {
            vote.value = value;
            showFeedbackPopover.value = true;
        }
    }

    async function recordResponse() {
        if (response.value === '') {
            showFeedbackPopover.value = false;
            return;
        }

        const { data, error } = await useFetch<{ success: boolean }>(
            'feedback'
        ).post({
            uid,
            text: response.value,
            vote: vote.value,
        });

        if (error.value) {
            toast.error('Ihre Rückmeldung konnte nicht gespeichert werden.');
            console.error(error.value);
            return;
        }

        if (data.value?.success === true) {
            showFeedbackPopover.value = false;
            response.value = '';
            toast.success('Vielen Dank, wir haben Ihre Rückmeldung erhalten!');
        } else {
            toast.error(
                'Ihre Antwort konnte aufgrund eines Fehlers nicht gespeichert werden.'
            );
        }
    }

    return {
        vote,
        response,
        recordVote,
        recordResponse,
        showFeedbackPopover,
    };
}
